var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"datasource-container"},[_c('LoginSetting',{ref:"LoginSetting",attrs:{"device_type":"PC","customData":_vm.customData}}),_c('ConfirmBox',{ref:"confirm"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }